import { usePreviewWrapper } from './hooks';
import { PatientsPreview } from './PatientsPreview.tsx';
import { RecordsPreview } from './RecordsPreview.tsx';
import { TasksPreview } from './TasksPreview.tsx';
import { UsersPreview } from './UsersPreview.tsx';

export const PreviewWrapper = () => {
  const { report } = usePreviewWrapper();

  switch (report?.report_type) {
    case 'patients_report':
      return <PatientsPreview />;
    case 'tasks_report':
      return <TasksPreview />;
    case 'users_report':
      return <UsersPreview />;
    case 'records_report':
      return <RecordsPreview />;
    default:
      return <></>;
  }
};
